import React, { useEffect } from 'react';
import { PageHeader, Button } from '../../components/shared';
import styles from './Account.scss';
import { clientInfoContext } from '../../contexts/ClientInfoContext';
import { config } from '../../../config';

const images = require.context('../../images/reps', true);

const Account = props => {
  const { client } = props;
  const {
    suiteName,
    companyName,
    suiteType,
    suiteClient,
    repInfo,
    guest_passes,
    parking_location,
    parking_passes,
    parking_location_2,
    parking_passes_2,
    parking_location_3,
    parking_passes_3,
    parking_location_4,
    parking_passes_4,
    parking_location_5,
    parking_passes_5,
    Contracted_tickets,
    end_year_contact_date,
    tickets_available,
  } = client;
  console.log('🚀 ~ client:', client);
  // console.log('🚀 ~ suiteType:', suiteType);
  // console.log('🚀 ~ repInfo:', repInfo);

  const repAvatar = (() => {
    if (!repInfo || !repInfo.rep_name) {
      return './default.jpg';
    }
    switch (repInfo.rep_name) {
      case 'Vanessa Reid':
        return './rep1.jpg';
      case 'Austin Hansen':
        return './rep2.jpg';
      case 'Chrissy Van Allen':
        return './rep3.jpg';
      default:
        return '';
    }
  })();
  if (!client || Object.keys(client).length === 0)
    return (
      <div className={styles.account}>
        <div className={styles.account__content}>
          <h1 style={{ textAlign: 'center', marginTop: '100px' }}>
            No purl found
          </h1>
        </div>
      </div>
    );
  return (
    <div className={styles.account}>
      <PageHeader title="Your Account" />
      <div className={styles.account__content}>
        <section>
          <div className={styles.account__header}>
            <div className={styles.account__header__left}>
              <span className={styles.label}>Welcome</span>
              <h2 className={styles.welcome__text}>
                {suiteClient?.company_name}
              </h2>
            </div>
            <div className={styles.account__header__right}>
              <div>
                {suiteClient?.contact_id && (
                  <div>
                    <p>
                      <span className={styles.label}>Account Number</span>
                      <br />
                      {(() => {
                        const value = suiteClient?.contact_id;
                        if (value == null) return '';

                        const normalized = String(value)
                          .replace(/&#124;|&vert;/gi, '|') // HTML-encoded pipes
                          .replace(/[｜︱∣⎟]/g, '|'); // Unicode vertical bars

                        const parts = normalized
                          .split('|')
                          .map(s => s.trim())
                          .filter(Boolean);

                        if (parts.length <= 1) return value;

                        return parts.map((p, i) => (
                          <React.Fragment key={i}>
                            <span className={styles.small}>{p}</span>
                            {i < parts.length - 1 && <br />}
                          </React.Fragment>
                        ));
                      })()}
                    </p>
                  </div>
                )}
                {suiteType?.type && (
                  <div>
                    <p>
                      <span className={styles.label}>Suite type</span>
                      <br /> {suiteType.type}
                    </p>
                  </div>
                )}
                {suiteName && (
                  <div>
                    <p>
                      <span className={styles.label}>Suite Number</span>
                      <br /> {suiteName}
                    </p>
                  </div>
                )}
                {Contracted_tickets && (
                  <div>
                    <p>
                      <span className={styles.label}>
                        # of Base Suite Tickets
                      </span>
                      <br /> {Contracted_tickets}
                    </p>
                  </div>
                )}
                {tickets_available && (
                  <div>
                    <p>
                      <span className={styles.label}># of Available SROs</span>
                      <br /> {tickets_available}{' '}
                      <span className={styles.small_label}>(per game)</span>
                    </p>
                  </div>
                )}
                {guest_passes && (
                  <div>
                    <p>
                      <span className={styles.label}># of guests passes</span>
                      <br /> {guest_passes}{' '}
                      <span className={styles.small_label}>(per game)</span>
                    </p>
                  </div>
                )}
                {/* {end_year_contact_date && (
                  <div>
                    <p>
                      <span className={styles.label}>contract end date</span>
                      <br /> {end_year_contact_date}
                    </p>
                  </div>
                )} */}
                {parking_location && (
                  <div>
                    <p>
                      <span className={styles.label}>Primary Parking</span>
                      <br /> {parking_location}
                    </p>
                  </div>
                )}
                {parking_passes && (
                  <div>
                    <p>
                      <span className={styles.label}># of Parking Passes</span>
                      <br /> {parking_passes}
                    </p>
                  </div>
                )}
                {parking_location_2 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>Secondary Parking</span>
                      <br /> {parking_location_2}
                    </p>
                  </div>
                )}
                {parking_passes_2 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>
                        # of Secondary Parking Passes
                      </span>
                      <br /> {parking_passes_2}
                    </p>
                  </div>
                )}
                {parking_location_3 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>Additional Parking</span>
                      <br /> {parking_location_3}
                    </p>
                  </div>
                )}
                {parking_passes_3 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>
                        # of Additional Parking Passes
                      </span>
                      <br /> {parking_passes_3}
                    </p>
                  </div>
                )}
                {parking_location_4 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>Additional Parking</span>
                      <br /> {parking_location_4}
                    </p>
                  </div>
                )}
                {parking_passes_4 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>
                        # of Additional Parking Passes
                      </span>
                      <br /> {parking_passes_4}
                    </p>
                  </div>
                )}
                {parking_location_5 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>Additional Parking</span>
                      <br /> {parking_location_5}
                    </p>
                  </div>
                )}
                {parking_passes_5 && (
                  <div className={styles.col2}>
                    <p>
                      <span className={styles.label}>
                        # of Additional Parking Passes
                      </span>
                      <br /> {parking_passes_5}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.account__header__info}>
            <h3>
              As part of our exclusive service, we invite our valued clients to
              share more about themselves by completing a personalized
              information form.
            </h3>
            <Button
              text="Complete Form"
              btnType="purple"
              href="https://minnesotavikings.formstack.com/forms/premium_get_to_know_you_2023"
              externalLink
            />
          </div>
        </section>

        <section className={styles.premium__team}>
          <img
            src={`${config.BASE_URL}/${repInfo.photo.path}`}
            alt="Account Manager"
            className={styles.premium__team__image}
          />

          <div className={styles.premium__team__info}>
            <h2 className={styles.section__title}>Your Premium Team</h2>
            <div className={styles.premium__team__right}>
              <p className={styles.team__member__name}>
                {repInfo.rep_name}
                <br />
                <span> {repInfo.rep_title}</span>
              </p>
              <p className={styles.team__member__email}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clipPath="url(#clip0_15_7048)">
                    <path
                      d="M16.165 3.00002C16.0969 2.993 16.0282 2.993 15.96 3.00002H1.96001C1.87028 3.0014 1.78115 3.01485 1.69501 3.04002L8.92001 10.235L16.165 3.00002Z"
                      fill="#FEC326"
                    />
                    <path
                      d="M16.905 3.69501L9.62503 10.945C9.43766 11.1313 9.18421 11.2358 8.92003 11.2358C8.65584 11.2358 8.40239 11.1313 8.21503 10.945L1.00003 3.75001C0.977847 3.83153 0.966086 3.91553 0.965027 4.00001V14C0.965027 14.2652 1.07038 14.5196 1.25792 14.7071C1.44546 14.8947 1.69981 15 1.96503 15H15.965C16.2302 15 16.4846 14.8947 16.6721 14.7071C16.8597 14.5196 16.965 14.2652 16.965 14V4.00001C16.961 3.89583 16.9408 3.79293 16.905 3.69501ZM2.65003 14H1.95503V13.285L5.59003 9.68001L6.29503 10.385L2.65003 14ZM15.955 14H15.255L11.61 10.385L12.315 9.68001L15.95 13.285L15.955 14Z"
                      fill="#FEC326"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_15_7048">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {repInfo.rep_email}
              </p>
              <p className={styles.team__member__email}>
                <svg fill="#FEC326" width="20" height="20" viewBox="0 0 24 24">
                  <path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z" />
                </svg>
                {repInfo.rep_phone}
              </p>
            </div>
          </div>
        </section>

        {suiteType?.type !== 'Norseman Lounge Suites' && (
          <section className={styles.suite__catering}>
            <div className={styles.content}>
              <h2 className={styles.section__title}>Your Suite Catering</h2>
              <p>
                Aramark embodies the distinctive tastes and characteristics of
                U.S. Bank Stadium and will create a modern and memorable
                culinary experience for you.
              </p>
              <a
                href="https://preorder.tapin2.co/2224"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className={styles.btn__catering}>
                  Aramark Suite Catering
                </button>
              </a>
            </div>
            <div className={styles.image}>
              <img src={images('./catering.jpg')} alt="" />
            </div>
          </section>
        )}
      </div>
    </div>
  );
};
// Vanessa Reid
// Senior Director, Guest & Premium Experience

// Austin Hansen
//  Manager, Premium Experience & Operations

// Chrissy Van Allen
// Premium Experience Coordinator
export default React.forwardRef((props, ref) => (
  <clientInfoContext.Consumer>
    {client => <Account {...props} client={client} ref={ref} />}
  </clientInfoContext.Consumer>
));
